<template>
<div class="contact">
    <div class="nav">
        <div class="close" @click="toggleContact()">
            <IconCancel class="icon-cancel" />
        </div>
    </div>
    <div class="contact-text-wrap">
        <small class="info-text">
          Formation is independently created by <a href="mailto:niklaz@mesh-in.com">Niklaz Lönnqvist</a>.
          <br><br>
          Niklaz is a designer and developer based in Stockholm, Sweden. He is also the founder of <a href="https://mesh-innovation.com" target="_blank">MESH Innovation</a> - a web development studio specialized in building and designing products for the internet.
          <br><br>
          Please come say hello in our dedicated <a href="https://communityinviter.com/apps/formation-fyi/formation" target="_blank">Slack channel</a>. Would love to hear what you think and if you have any feedback, ideas or suggestions.
          <br><br>
          For news and updates:
          &nbsp;
          <a href="https://www.instagram.com/formation.network/" target="_blank">Instagram</a>
          &nbsp;
          <a href="https://twitter.com/formation_fyi" target="_blank">Twitter</a>
          &nbsp;
          <a href="https://communityinviter.com/apps/formation-fyi/formation" target="_blank">Slack</a>
        </small>
    </div>
</div>
</template>

<script>
import IconCancel from '../assets/icons/IconCancel.vue'

export default {
  name: 'Contact',
  components: {
    IconCancel
  },
  data() {
    return {

    }
  },
  methods: {
    toggleMenu() {
      this.$store.commit('toggleMenu')
    },
    toggleContact(payload) {
      this.$store.commit('toggleContact', payload)
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
  }
}
</script>
<style lang="scss" scoped>
.contact {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $black;
    z-index: 40;
    overflow: scroll;
    .nav {
      
        display: flex;
        height: $nav-height;
        width: 100%;
        align-items: center;
        justify-content: flex-end;
        .close {
          position: fixed;
            .icon-cancel {
                fill: $white;
                &:hover {
                    fill: $icon-hover-color;
                }
            }
        }
    }
    .contact-text-wrap {
        padding: $nav-height $grid-padding;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        h1 {
            font-size: $big-h1;
            color: $white;
        }
        h2 {
            color: $white;
            max-width: 600px;
        }
        .info-text {
        //   padding: 40vh 0;
          font-family: $family-reading;
          color: $grey;
          align-self: flex-start;
          max-width: 360px;
          a {
            text-decoration: underline;
            &:hover {
              text-decoration: line-through;
            }
          }
        }
    }
}
// MOBILE
@media #{$mobile} {
.contact {
  .contact-text-wrap {
      padding: $nav-height-mobile $main-margin-mobile;
      h1 {
        font-size: 1.4rem;
      }
      h2 {
        font-size: 1rem;
      }
  }

}

}

</style>